import { Model } from 'vue-models'

export default class Template extends Model {
  static defaults () {
    return {
      name: 'template',
      basePath: 'export-templates'
    }
  }
  static schema () {
    return {
      id: { type: Number },
      name: { type: String },
      description: { type: String },
      send_email: { type: Object },
      extra_report_emails: { type: Array, items: { type: String } },
      filters: {
        type: Object,
        properties: {
          search: { type: String },
          status: { type: Array, items: { type: String } },
          health: { type: Array, items: { type: String } },
          dta: { type: String },
          order_dta: { type: String },
          pol_loc: { type: String },
          pod_loc: { type: String },
          eta_0: { type: String },
          eta_1: { type: String },
          etd_0: { type: String },
          etd_1: { type: String },
          last_update_0: { type: String },
          last_update_1: { type: String },
          created_at_0: { type: String },
          created_at_1: { type: String }
        }
      },
      columns: { type: Array, items: { type: String } },
      user: { type: Number }
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/template.js